import '@adyen/adyen-web/dist/adyen.css';
import 'frontend-payments/assets/tailwind.css';
import '@mylighthouse/prism-ember/global-styles.css';
import 'frontend-payments/assets/app.css';
import 'password-form/app/styles/password-form/index.css';
import 'core-js/stable';
/**
 * Required for compiling generators/async functions to ES5. Can be removed once we drop old browser support.
 * https://babeljs.io/docs/babel-polyfill
 */
import 'regenerator-runtime/runtime';
import 'decorator-transforms/globals';

import Application from '@ember/application';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import config from 'frontend-payments/config/environment';
import { initializeErrorTracking } from 'frontend-utils/services/error-tracking';

initializeErrorTracking(config['@sentry/ember'].sentry);

export default class App extends Application {
  inspector = setupInspector(this);
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
